<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="客户类型">
              <a-select
                v-model="queryParam.custType"
                placeholder="请选择客户类型"
              >
                <a-select-option value="0">机构</a-select-option>
                <a-select-option value="1">个人</a-select-option>
                <a-select-option value="2">
                  产品
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="客户名称">
              <a-input
                placeholder="请输入客户名称"
                v-model="queryParam.realName"
              ></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="手机号">
                <a-input
                  placeholder="请输入手机号"
                  v-model="queryParam.mobile"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="证件号">
                <a-input
                  placeholder="请输入证件号"
                  v-model="queryParam.cerNum"
                ></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 导入 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handelExport"
        >导出</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" @click="handelDelete()"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
          <a-menu-item key="0" @click="handelBlack(1)"
            ><a-icon type="plus" />批量加入黑名单</a-menu-item
          >
          <a-menu-item key="1" @click="handelBlack(0)"
            ><a-icon type="line" />批量移除黑名单</a-menu-item
          >
        </a-menu>
        <a-button> 批量操作 <a-icon type="down"/></a-button>
      </a-dropdown>
    </div>
    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
      <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
      <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
      >项
      <a style="margin-left: 24px" @click="onClearSelected">清空</a>
    </div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{ x: true }"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      class="j-table-force-nowrap"
      @change="handleTableChange"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handlDelete(record.id)">删除</a>
      </span>
      <template slot="isBlackList" slot-scope="text, record">
        <a-switch
          :checked="isChecked(record.isBlackList)"
          checked-children="禁用"
          un-checked-children="未禁用"
          @click="handleChange(record)"
        />
      </template>
    </a-table>
    <a-modal
      :title="title"
      :visible="blackVisible"
      :width="width"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <a-form>
        <a-form-item
          label="原因:"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
        >
          <a-textarea
            v-model="reason"
            placeholder="请输入原因"
            :auto-size="{ minRows: 3, maxRows: 3 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JDate from '@/components/jeecg/JDate';
import { filterObj } from '@/utils/util';
import { getAction, downFiles, postTag } from '@/api/manage';
import {
  customerDelete,
  customerList,
  addBlackListMessage,
  handlDelete
} from '@/api/api';
export default {
  name: 'ProductsQuotationList',
  mixins: [mixinDevice],
  components: {
    JDate
  },
  data() {
    return {
      blackType: 1,
      isSingleBlack: false,
      isBlackList: 1,
      reason: '',
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      form: this.$form.createForm(this, { name: 'coordinated' }),
      blackVisible: false,
      title: '加入黑名单',
      width: 800,
      fileList: [],
      showDialog: false,
      visible: false,
      showLead: false,
      uploading: false,
      loading: false,
      reason: '', //驳回原因
      queryParam: {
        custType: '',
        realName: '',
        cerNum: '',
        mobile: ''
      },
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '客户名称',
          align: 'center',
          sorter: true,
          dataIndex: 'realName'
        },
        {
          title: '证件类型',
          align: 'center',
          dataIndex: 'cerType'
        },
        {
          title: '证件号码',
          align: 'center',
          dataIndex: 'cerNum'
        },
        {
          title: '客户类型',
          align: 'center',
          dataIndex: 'custType',
          customRender: function(text) {
            if (text == 1) {
              return '个人';
            } else if (text == 0) {
              return '机构';
            } else if (text == 2) {
              return '产品';
            } else {
              return;
            }
          }
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'mobile'
        },
        {
          title: 'email',
          align: 'center',
          dataIndex: 'email'
        },
        {
          title: '黑名单状态',
          align: 'center',
          dataIndex: 'isBlackList',
          scopedSlots: { customRender: 'isBlackList' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CUSTOMER + '/customer/list',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productQuotation/importExcel',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/userInfo/exportXls',
        joinBlackBatch:
          process.env.VUE_APP_CMS_CUSTOMER + '/customer/blacklist/addBatch ',
        batchLoadUrl: process.env.VUE_APP_CMS_CUSTOMER + '/customer/exportXls',
        batchDelete: process.env.VUE_APP_CMS_CUSTOMER + '/customer/deleteBatch'
      },
      id: '',
      selectedRowKeys: [],
      toggleSearchStatus: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //批量删除
    handelDelete() {
      let that = this;
      let ids = this.selectedRowKeys;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postTag(that.url.batchDelete, { ids: ids })
            .then(res => {
              if (res.success) {
                that.getList();
                that.onClearSelected();

                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    //d导出
    handelExport() {
      downFiles(this.url.batchLoadUrl).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            '客户注册统计数据表' + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '客户注册统计数据表' + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          // this.searchQuery();
        }
      });
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    //加入黑名单
    handelBlack(type) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        this.blackType = type;
        this.isSingleBlack = true;
        this.blackVisible = true;
      }
    },
    //批量加入黑名单
    batchBlack(type) {
      let ids = this.selectedRowKeys;
      var that = this;
      that.loading = true;
      postTag(that.url.joinBlackBatch, { ids: ids, isBlackList: type })
        .then(res => {
          if (res.success) {
            that.$message.success(res.message);
            that.ipagination.pageNo = 1;
            that.getList();
            that.onClearSelected();
            this.blackVisible = false;
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
          that.isSingleBlack = false;
        });
    },
    //用户选择
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      console.log(this.selectedRowKeys);
    },
    channel() {
      this.showDialog = true;
    },
    //excel转换
    productToLead() {
      this.showLead = true;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },

    searchQuery() {
      this.getList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    handlDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          customerDelete({ id: id })
            .then(res => {
              if (res.success) {
                that.getList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      customerList(params).then(res => {
        that.loading = true;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];

          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },

    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },

    handleCancel() {
      this.blackVisible = false;
      this.reason = '';
    },
    //启用、停用
    handleChange(record) {
      console.log(1);
      this.id = record.id;
      this.blackVisible = true;

      this.isBlackList = record.isBlackList == 1 ? 0 : 1;
      this.title = record.isBlackList == 1 ? '取消加入黑名单' : '加入黑名单';
    },
    handleOk() {
      if (!this.isSingleBlack) {
        this.singleBlack();
      } else {
        this.batchBlack(this.blackType);
      }
      // if (this.reason == '') {
      //   return '请输入拉入黑名单原因';
      // }
    },
    //单个加入黑名单
    singleBlack() {
      addBlackListMessage({
        id: this.id,
        reason: this.reason,
        isBlackList: this.isBlackList
      }).then(res => {
        if (res.success) {
          this.$message.success(res.message);
          this.blackVisible = false;
          this.reason = '';
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    isChecked(statusTemp) {
      if (statusTemp == 1) {
        return true;
      } else return false;
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.getList(1);
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
